import { render } from "./ManageFacilities.vue?vue&type=template&id=dd7dcf34&scoped=true&ts=true"
import script from "./ManageFacilities.vue?vue&type=script&lang=ts"
export * from "./ManageFacilities.vue?vue&type=script&lang=ts"

import "./ManageFacilities.vue?vue&type=style&index=0&id=dd7dcf34&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd7dcf34"]])

export default __exports__